module.exports = __webpack_public_path__ + "img/laptop-screenshot.1acab93c.png";